// extracted by mini-css-extract-plugin
module.exports = {"connection--delete":"Subscriptions_connection--delete__3Uh6S","table-action--buttons":"Subscriptions_table-action--buttons__2nYTm","margin-top":"Subscriptions_margin-top__3r4Jq"};